
export type DiscoveryGetTrendsCategory = typeof DiscoveryGetTrendsCategory[keyof typeof DiscoveryGetTrendsCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrendsCategory = {
  ALL: 'ALL',
  NEWS: 'NEWS',
  SPORTS: 'SPORTS',
  ENTERTAINMENT: 'ENTERTAINMENT',
  TECHNOLOGY: 'TECHNOLOGY',
} as const;
